<template>
  <v-app>
    <v-container>
      <v-row justify="center">
        <v-col
          v-for="art in artworks"
          :key="art.img"
          class="d-flex justify-center"
          cols="auto"
          style="flex: 1 1 300px;"
        >
          <v-card
            class="ma-2"
            max-width="300"
            @click="openArt(art)"
            hover
            ripple
          >
            <v-img
              :src="art.img"
              height="300"
              cover
            /> 
          </v-card>
        </v-col>
      </v-row>
    </v-container>

  <v-dialog v-model="dialogOpen" max-width="600" max-height="800">
  <v-card v-if="selectedArt"
  >
    <!-- <v-img
      :src="selectedArt.img"
      height="300"
      cover
    /> -->

    <!-- <v-img
      :src="selectedArt.img"
      max-height="160"
      max-width="160"
      contain
      class="mx-auto my-4 rounded"
    />

    <v-card-title>
      {{ selectedArt.title }}
    </v-card-title> -->

      <v-row no-gutters align="start">
        <!-- TEXT -->
        <v-col cols="8" class="pa-4">
          <v-card-title class="text-h6 pa-0">
            {{ selectedArt.title }}
          </v-card-title>

          <v-card-text class="pa-0 mt-2">
            <p v-if="selectedArt.artist"><strong>Kunstner:</strong> {{ selectedArt.artist }}</p>
            <p v-if="selectedArt.year"><strong>År:</strong> {{ selectedArt.year }}</p>
            <p class="mt-2">
              {{ selectedArt.description }}
            </p>
          </v-card-text>
        </v-col>
            <!-- ARTWORK -->
        <v-col cols="4" class="pa-4 d-flex justify-end">
          <v-img
            :src="selectedArt.img"
            max-width="160"
            aspect-ratio="1"
            contain
            class="rounded elevation-1"
          />
        </v-col>
      </v-row>

    <v-card-text>
      <!-- <p v-if="selectedArt.artist"><strong>Kunstner:</strong> {{ selectedArt.artist }}</p>
      <p v-if="selectedArt.year"><strong>År:</strong> {{ selectedArt.year }}</p>
      <p class="text--secondary">{{ selectedArt.description }}</p> -->
      <vuetify-audio v-if="selectedArt.samplefile" :file="selectedArt.samplefile" :key="audioKey" flat :ended="audioFinish" ></vuetify-audio>

      <v-list dense>

        <v-list-item v-if="selectedArt.spotify" :href="selectedArt.spotify" target="_blank">
          <v-list-item-icon>
            <v-icon color="#1DB954">mdi-spotify</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Lyt på Spotify</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="selectedArt.apple" :href="selectedArt.apple" target="_blank">
          <v-list-item-icon>
            <v-icon>mdi-apple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Lyt på Apple Music</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="selectedArt.tidal" :href="selectedArt.tidal" target="_blank">
          <v-list-item-icon>
            <v-img width="16" aspect-ratio="1/1"  cover :src=tidal></v-img>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Lyt på Tidal</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="selectedArt.youtube" :href="selectedArt.youtube" target="_blank">
          <v-list-item-icon>
            <v-icon color="#FF0000">mdi-youtube</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Lyt på YouTube</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

    </v-card-text> 

    <v-card-actions>
      <v-btn
        text
        @click="copyLink"
      >
        <v-icon small>mdi-link-variant</v-icon>
        Kopier link
      </v-btn>

      <v-spacer />

      <v-btn text @click="closeDialog">Luk</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

  <v-snackbar
    v-model="snackbar"
    timeout="2000"
    top
    color="#2e7d32"
    dark
    centered
  >
    <div class="snackbar-center">
      <v-icon left>mdi-check</v-icon>
      {{ snackbarText }}
  </div>
</v-snackbar>


  </v-app>
</template>

<script>


import lajs from "../../public/artwork/lajs.jpg"
import lajsSample from "../../public/samples/LajsSample.mp3"

import nogetdope from  "../../public/artwork/nogetdope.jpeg"
import nogetDopeSample from "../../public/samples/NogetDopeSample.mp3"

import rendezvous from  "../../public/artwork/rendezvous.jpg"
import rendezvousSample from "../../public/samples/RendezvousSample.mp3"

import detførste from  "../../public/artwork/detførste.jpg"
import detFørsteSample from "../../public/samples/MATLABSample.mp3"

import gørdetbare from  "../../public/artwork/gørdetbare.jpg"
import gørDetBareSample from "../../public/samples/GørDetBareSample.mp3"

import topmotiveret from  "../../public/artwork/topmotiveret.jpg"


import tidallogo from '../assets/tidal.png'
export default {
    name: 'MainSec',
    components: {
      VuetifyAudio: () => import('vuetify-audio'),
    },

  data: () => ({
    // for hver art skal der laves et card med album - Nyest øverst
    artworks: [
        {img: lajs, 
          id: "lajs",
          title: "Lajs ft. J.C. (Single)", 
          artist: "Chippo ft. J.C.", 
          year: "2026", 
          spotify: "https://open.spotify.com/album/40YOFhNIBPcXHd1qCXTmRT?si=PQibA1D3RmCHorYmxrsZDg",
          apple: "https://music.apple.com/us/album/lajs-feat-j-c-single/1874745251",
          youtube: "https://youtu.be/lUY2XbidURw?si=k-PqwstreUcvm4SL",
          tidal: "https://tidal.com/album/495561058/track/495561059",
          samplefile: lajsSample,

        }
          ,
        {img: nogetdope, 
          id: "nogetdope",
          title: "Noget Dope (Album)", 
          artist: "Chippo", 
          year: "2022",
          spotify: "https://open.spotify.com/album/740f69d9iCiRgw53qpFBR6?go=1",
          apple: "https://music.apple.com/dk/album/1632527604?app=music&at=1l3vpUI&ct=LFV_08d2802e5a7015980c7461d3b1f631f5&itscg=30440&itsct=catchall_p1&lId=26028301&cId=none&sr=1&src=Linkfire&ls=1",
          youtube: "https://www.youtube.com/playlist?list=OLAK5uy_mUf6A73tIXvQgy4gydM5HbgeroNhKj91Y",
          tidal: "https://tidal.com/album/236083933/",
          samplefile: nogetDopeSample,
        },
        {img: rendezvous, 
          id: "rendevous",
          title: "Rendezvous (Podcast)", 
          year: "2021",
          description: "Hør med når Yves Le Lay taler med store gastronomer om deres forhold til mad og deres liv i restaurationsbranchen. Alle episoderne er optaget på Yves' restaurant à terre. Gæsterne i første sæson er Simon Jul, Gorm Wisweh, Martin Kongstad, Hot dog John, Francis Cardenau, Umut Sakarya, Jakob Mielcke og Thomas Castberg.",
          spotify: "https://open.spotify.com/show/7Dx6EFOkC90GzCjCF9B1Mm?si=15d888b78dca42b2",
          samplefile: rendezvousSample,
        },
        {img: detførste, 
          id: "detfoerste",
          title: "Det Første (Album)", 
          artist: "Chippo", 
          year: "2020",
          description: "Debutalbum fra Chippo, med gæsteoptrædener fra J.C. der dengang gik under navnet Levi.",
          spotify: "https://open.spotify.com/album/7nfDkOKGKjuh1n4z3nENzI?si=wCcGMX0aT_mGw6jbeRdcNw",
          apple: "https://music.apple.com/us/album/det-f%C3%B8rste/1504351589",
          youtube: "https://youtube.com/playlist?list=OLAK5uy_m-ycI_xYH2yEBBBv4B-5kQAL8uU-zgIzY&si=9wCVMF64j_iweleD",
          tidal: "https://tidal.com/album/135362903",
          samplefile: detFørsteSample,
        },
        {img: gørdetbare, 
          id: "goerdetbare",
          title: "Gør Det Bare (Single)", 
          artist: "Chippo ft. J.C.", 
          year: "2020",
          description: "Anden single fra debutalbummet 'Det Første'.",
          spotify: "https://open.spotify.com/album/7uciaAJWOXiTPe6AUNypF1?si=zeO-w3nnQ0qRmj4mGyFw6Q",
          apple: "https://music.apple.com/us/album/g%C3%B8r-det-bare-feat-levi-single/1495725517?uo=4",
          youtube: "https://youtu.be/2B1XBvwZy3Y?si=OzY_Mik0E9O-rHgl",
          tidal: "https://tidal.com/album/128491318",
          samplefile: gørDetBareSample,
        },
        {img: topmotiveret, 
          id: "topmotiveret",
          title: "Topmotiveret", 
          artist: "Chippo ft. J.C.", 
          year: "2019",
          description: "Første single fra debutalbummet 'Det Første'.",
          spotify: "https://open.spotify.com/album/4KNsR4SSo7n2Z3vqPPBs3y?si=i6COyDpJTwOGLOQb5CW37g",
          apple: "https://music.apple.com/us/album/topmotiveret-feat-levi-single/1484878269",
          youtube: "https://youtu.be/SliYge0_eSI?si=pwdTTgGY0qoGLDhj",
          tidal: "https://tidal.com/album/120961872",
        }
    ],
    dialogOpen: false,
    snackbar: false,
    snackbarText: '',
    audioKey: 0, // Used to reset audio component
    tidal: tidallogo,
  }),

    computed: {
    // The artwork corresponding to the current route
    selectedArt() {
      const artId = this.$route.params.id
      return this.artworks.find(art => art.id === artId) || null
    },
    dynamicOgUrl() {
      if (!this.selectedArt) return 'https://rosenrecords.dk/img/lajs.95099845.jpg'
      return `https://rosenrecords.dk/api/og?title=${encodeURIComponent(this.selectedArt.title)}&img=${encodeURIComponent(this.selectedArt.img)}`
    },
    dialog: {
      get() {
        return !!this.selectedArt
      },
      set(val) {
        if (!val) {
          // Close dialog → navigate back to /gallery
          this.$router.push({ name: 'gallery' })
        }
      }
    }
  },
  mounted() {
  // On page load, if URL has an id, open the dialog
  if (this.$route.params.id && this.selectedArt) {
    this.dialogOpen = true
  }
  },
  watch: {
    selectedArt(art) {
      if (!art) return
       // Signal prerenderer
      document.dispatchEvent(new Event("render-event"))
      document.title = `${art.title} – RosenRecords`

      this.setMeta("og:title", `${art.title} – RosenRecords`)
      this.setMeta(
        "og:image",
        `https://rosenrecords.dk/api/og?title=${encodeURIComponent(art.title)}&img=${encodeURIComponent(art.img)}`
      )
      this.setMeta("og:type", "website")
      this.setMeta("og:url", window.location.href)


        // this.setMeta("og:image", this.dynamicOgUrl)

    },
    dialogOpen(val) {
      if (!val) {
        this.handleDialogClose()
      }
    }
},
  methods: {
    
    openArt(art) {
      this.$router.push({ name: 'gallery', params: { id: art.id } })
      this.dialogOpen = true
    },

    closeDialog() {
      this.dialogOpen = false
    },

    handleDialogClose() {
      document.title = `RosenRecords`
      this.dialogOpen = false
      this.$router.push({ name: 'gallery' })
      this.setMeta("og:title", `RosenRecords`)
      // this.setMeta(
      //   "og:image",
      //   `https://rosenrecords.dk/api/og?title=${encodeURIComponent(art.title)}&img=${encodeURIComponent(art.img)}`
      // )
      this.setMeta("og:url", window.location.href)
      this.audioKey++ // Reset audio component to stop playback when dialog is closed
    },

    copyLink() {
      const url = window.location.href
      navigator.clipboard.writeText(url)
        .then(() => {
          this.showSnackbar('Link kopieret!')
        })
        .catch(() => {
          this.showSnackbar('Kunne ikke kopiere linket.')
        })
      },

      showSnackbar(text) {
        this.snackbarText = text
        this.snackbar = false
        this.$nextTick(() => {
          this.snackbar = true
        })
      },

      setMeta(property, content) {
        let tag = document.querySelector(`meta[property="${property}"]`)
        if (!tag) {
          tag = document.createElement("meta")
          tag.setAttribute("property", property)
          document.head.appendChild(tag)
        }
        tag.setAttribute("content", content)
      }

  }
}
</script>

<style>
  h3 {text-align: left;}
  .tis {
    align-items: center;
    align-self: center;
    justify-content: center;
  }
  .tab { margin-left: 20px; }
</style>

<style type="text/css">

</style>